import { createTransform } from 'redux-persist';
import localStorage from 'redux-persist/lib/storage';
import localForage from 'localforage';

import { caslCreateAbilityForUser } from '@utils/casl/ability';

const isDebug = process.env.NODE_ENV !== 'production';

const SetTransform = createTransform(
  // Inbound: serialize ability rules explicitly before storing
  (inboundState: any) => {
    if (inboundState.ability) {
      return {
        ...inboundState,
        ability: inboundState.ability.rules || [],
      };
    }
    return inboundState;
  },
  // Outbound: reconstruct PureAbility from stored rules array
  (outboundState: any) => {
    const rules = Array.isArray(outboundState.ability)
      ? outboundState.ability
      : [];
    const ability = caslCreateAbilityForUser(rules);
    return { ...outboundState, ability };
  },
  { whitelist: ['me'] },
);

localForage.config({
  name: `medwork-${process.env.NODE_ENV}`,
  storeName: `medwork-${process.env.NODE_ENV}`,
});

export const rootPersistConfig = {
  key: 'root',
  storage: localForage,
  debug: isDebug,
  whitelist: ['me'],
  transforms: [SetTransform],
};

export const authPersistConfig = {
  key: 'auth',
  storage: localStorage,
  debug: isDebug,
  blacklist: ['auth'],
};
